// extracted by mini-css-extract-plugin
export var active = "_vn-1";
export var circle = "_vn-0";
export var completed = "_vn-2";
export var connector = "_vn-4";
export var connectorCompleted = "_vn-7";
export var connectorSpacer = "_vn-5";
export var iconStrokeOverride = "_vn-8";
export var labelContainer = "_vn-6";
export var pending = "_vn-3";